<template>
    <div class="tipo-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="400">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-form ref="tipoForm" v-model="validTipo">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="tipoItem.nombre"
                                                label="Nombre"
                                                :rules="nombreFieldRules"
                                                :error-messages="nombreFieldErrors"
                                                :counter="255"
                                                @keydown="nombreFieldErrors = []"
                                                @keypress.enter.prevent="saveForm()"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
	export default {
		props: {
			formTitle: String,
			initialItem: Object
		},
		data () {
			return {
				loading: false,
				validTipo: false,
				tipoItem: {
					nombre: '',
				},
				nombreFieldRules: [
					v => !!v || 'Debe proporcionar un nombre',
					v => v.length <= 255 || 'El nombre solo puede contener 255 caracteres',
				],
				nombreFieldErrors: [],
			}
		},
		computed: {

			isNewRecord() {
				return this.initialItem === null
			},

			showForm: {
				get: function() {
					return true
				},
				set: function () {
					return this.cancelForm()
				}
			},

			disableSaveButton() {
				return this.loading || (!this.validTipo)
			}
		},

		methods:{
			saveForm() {
				this.loading = true
				this.$refs.tipoForm.validate()
				if (this.validTipo) {
					var tipo = {
						nombre: this.tipoItem.nombre,
					}

					if (!this.isNewRecord) {
						tipo.id = this.tipoItem.id
					}

					this.$store.dispatch(this.isNewRecord ? "ADD_TIPO" : "UPDATE_TIPO", tipo).then(result => {
						if (!result) {//no hay coneccion con el servidor
							this.loading = false
                        }
						if (result === null || result.status === 404 || result.status === 500) {
							//cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
							this.$emit("formCanceled")
						} else {
							// El backend devolvió error de validación, pasando los errores a los campos correspondientes
							let { data, status } = result
							if (status === 422) {
								data.forEach(error => {
									if (error.field === "nombre") {
										this.nombreFieldErrors.push(error.message)
									}
								})
							}
						}
						this.loading = false
					})
				} else {
					this.loading = false
				}
			},
			cancelForm() {
				this.$emit("formCanceled")
			}
		},

		created() {
			if (this.initialItem !== null) {
				// Cargando información del elemento a actualizar
				this.tipoItem.id = this.initialItem.id
				this.tipoItem.nombre = this.initialItem.nombre
			}
		},
	};
</script>

<style scoped>

</style>